import { PageHero } from "../components/PageHero";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/content";

const Block = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-heading text-navy-900 mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-1">{children}</div>
  </div>
);

export default function Impressum() {
  return (
    <>
      <Seo title="Impressum" description="Impressum von Energie-Tarifberater – Angaben gemäß § 5 TMG." path="/impressum" />
      <PageHero
        eyebrow="Rechtliches"
        titleLines={["Impressum"]}
        breadcrumb={[{ label: "Impressum" }]}
      />
      <section className="bg-background py-24">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-10">Angaben gemäß § 5 TMG</p>

            <Block title="Anbieter">
              <p className="font-medium text-navy-900">{CONTACT.responsible} (KHE)</p>
              <p>Energietarifberaterin im Auftrag der</p>
              <p>EED Vertriebs GmbH</p>
              <p>{CONTACT.street}</p>
              <p>{CONTACT.city}</p>
              <p>Deutschland</p>
            </Block>

            <Block title="Handelsregister">
              <p>Geschäftsführung: Selma Schneider</p>
              <p>Amtsgericht: Hamburg</p>
              <p>HRB: 160673</p>
            </Block>

            <Block title="Kontakt">
              <p>Telefon: +49 (0)172 444 7776</p>
              <p>
                E-Mail:{" "}
                <a href={CONTACT.emailHref} className="text-blue-700 hover:underline">
                  {CONTACT.email}
                </a>
              </p>
              <p>
                Web:{" "}
                <a href="https://www.energie-tarifberater.de" className="text-blue-700 hover:underline">
                  www.energie-tarifberater.de
                </a>
              </p>
            </Block>

            <Block title="Beauftragende Gesellschaft">
              <p>EED Vertriebs GmbH</p>
              <p>
                E-Mail:{" "}
                <a href="mailto:k.hemming@energie-experten-deutschland.de" className="text-blue-700 hover:underline">
                  k.hemming@energie-experten-deutschland.de
                </a>
              </p>
              <p>
                Internet:{" "}
                <a href="https://energie-experten-deutschland.de" target="_blank" rel="noopener noreferrer" className="text-blue-700 hover:underline">
                  https://energie-experten-deutschland.de
                </a>
              </p>
            </Block>

            <Block title="Verantwortlich für den Inhalt gemäß § 55 Abs. 2 RStV">
              <p>{CONTACT.responsible}</p>
            </Block>

            <Block title="Vertreten durch">
              <p>{CONTACT.responsible}</p>
            </Block>

            <Block title="Haftung für Inhalte">
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den
                allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet,
                übermittelte oder gespeicherte fremde Informationen zu überwachen.
              </p>
            </Block>

            <Block title="Haftung für Links">
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.
              </p>
            </Block>
          </Reveal>
        </div>
      </section>
    </>
  );
}
